import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ge7p3dn44: FaireProductEntity = {
  token: "p_4ge7p3dn44",
  type: "product",
  name: "Viral Mystery Dumpling Squishy  - Rainbow -Factory Sealed",
  brandToken: "b_dyufggjqdw",
  brandName: "Think Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/3a617abac60e80c09d1008740c4fba5b5a7596f825ebd828f05ac53400ac74e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2571ca7535e4c79719b79621559e1256dd37127e68dfa3913980798fcc57fcb.jpeg",
    "https://cdn.faire.com/fastly/bacee28f7ae51f443eb5ea06cfdcc5ba7b5307303656e9235455457df5263b84.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Think Sweet brings you the Viral  Dumpling Squishy, a delightful squishy in every box! Each dumpling squishy toy is a vibrant mix of nostalgia and new discoveries, designed to spark joy and bring people together. SOME MAY BE RAINBOW -with and without a face ! Best deal on dumplings now! \nFactory sealed ",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:42.231Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
